export enum LOGS_WEB_SERVICE_TYPES {
  PREMIUM_CALCULATION = 'PREMIUM_CALCULATION',
  ILLUSTRATIONS = 'ILLUSTRATIONS',
  MEDICAL_TEST = 'MEDICAL_TEST',
  PROPOSAL_SERVICE_INITIATOR = 'PROPOSAL_SERVICE_INITIATOR',
  PROPOSAL_PAYMENT = 'PROPOSAL_PAYMENT',
  PREMIUM_CALCULATION_PROPOSAL = 'PREMIUM_CALCULATION_PROPOSAL',
  ILLUSTRATIONS_PROPOSAL = 'ILLUSTRATIONS_PROPOSAL',
  UPLOAD_DOC = 'UPLOAD_DOC',
  UPLOAD_DOC_RE = 'UPLOAD_DOC_RESUBMIT',
  PROPOSAL_UPDATE_STATE = 'PROPOSAL_UPDATE_STATE',
  RECRUITMENT_AGENT_MASTER = 'RECRUITMENT_AGENT_MASTER',
  RECRUITMENT_AI_PREDICTION = 'RECRUITMENT_AI_PREDICTION',
  RECRUITMENT_AI_REMARK = 'RECRUITMENT_AI_REMARK'
}
